export default "__VITE_ASSET__b4c1529a__"